export default __webpack_public_path__ + "static/media/TITULOS_08.826b136a.png";